module.exports = __webpack_public_path__ + "media/images/500px-d3abea7fcf8aa2f6fba9b15b2ffcc12e.png";